import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CounsellorRegisterVM } from '../../../models/CounsellorRegisterVM';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { BaseComponent } from '../../base/base.component';
import { Utils, minAgeValidator } from '../../../utils/utils';
import { SignupService } from '../../../services/signup.service';
import { RegistrationResponse } from '../../../models';
import * as moment from 'moment';

@Component({
  selector: 'SignupComponent',
  templateUrl: './signup.component.html'
})
export class SignupComponent extends BaseComponent implements OnInit {

  model: CounsellorRegisterVM = new CounsellorRegisterVM();
  myForm: FormGroup;
  resendToken: string;

  signupStatus: boolean | null = null;

  constructor(private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private signService: SignupService
  ) {
    super(route);
  }

  ngOnInit(): void {

    let sub = this.route.params
      .subscribe(params => this.resendToken = params['token']);

    let emailRegEx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    this.myForm = this.fb.group({
      displayName: new FormControl('', Validators.required),
      age: new FormControl(null),
      dob: new FormGroup({}),
      email: new FormControl('', [Validators.email, Validators.required, Validators.pattern(emailRegEx)]),
      password: new FormControl('', [Validators.required, Validators.pattern(this.globalSettings.passwordRules)]),
      confirmPassword: new FormControl('', Validators.required),
      firstname: new FormControl('', Validators.required),
      lastname: new FormControl('', Validators.required),
      gender: new FormControl('', Validators.required),
      nationality: new FormControl('', Validators.required),
      mobile: new FormControl('', Validators.required),
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      postcode: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      state: new FormControl(null),
      qualification: new FormControl('', Validators.required),
      experience: [null, Validators.compose([
        Validators.required,
        Validators.pattern('([1-9]|1[0-9]|2[0-9]|3[0-9])')
      ])
      ],
    }, { validator: Utils.checkIfMatchingPasswords('password', 'confirmPassword') });
  }

  onSubmit(): void {
    this.signupStatus = null;
    this.markAsTouched(this.myForm);

    if (this.model.dateOfBirth == null) {
      return;
    }

    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      const self = this;
      this.signService.signup(this.model)
        .subscribe(
          result => {
            if (result != null) {
              this.signupStatus = true;
              this.resendToken = result;
            } else {
              this.signupStatus = false;
            }
          },
          err => {
            var errMsg = 'Error, Please try again.';
            switch (+err.json()) {
              case RegistrationResponse.emailAlreadyRegistered:
                errMsg = 'Email already registered, please use the forgotten password process to recover you\'re account details.';
                break;
              case RegistrationResponse.missingFormFields:
                errMsg = 'Please complete all fields and try again.';
                break;
              case RegistrationResponse.badData:
                errMsg = 'The information you have entered is incorrect, please try again.';
                break;
            }

            self.showDialog(errMsg, true);
            self.emitDisplayLoadingDialog(false);
            window.scrollTo(0, 0);
          },
          () => {
            self.emitDisplayLoadingDialog(false);
            window.scrollTo(0, 0);
          }
        );
    }
  }

  dateSelected(dob: string) {
    this.model.dateOfBirth = dob;
  }

  resend() {
    this.signService.resendVerifyAccount(this.resendToken)
      .subscribe(
        r => {
          if (r) {
            this.showDialog("Another email with a verification link has been sent to your inbox. Please check your junk folder.", false);
          }
          else {
            this.showDialog("Cannot request a resend, please check your account status", false);
          }
        },
        e => this.showDialog(e, true),
        () => { }
      );

    return false;
  }

}
